<template>
  <section class="table-sampler-result-vibration">
    <d-list-group flush class="custom-striped">
      <d-list-group-item
        class="d-flex px-3 py-4"
        v-for="(row, index) in model"
        v-bind:key="index"
      >
        <d-col class="col px-0">
          <d-form-row class="m-0 mb-1">
            <d-col cols="3">
              <label>Código </label>
              <input
                type="text"
                class="form-control"
                placeholder="Código"
                v-model="row.code"
                required
              />
            </d-col>

            <d-col cols="3">
              <label>Norma</label>
              <input
                type="text"
                class="form-control"
                placeholder="Norma"
                v-model="row.norm"
                required
              />
            </d-col>

            <d-col cols="3">
              <label>Método</label>
              <input
                type="text"
                class="form-control"
                placeholder="Método"
                v-model="row.method"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Critério</label>
              <input
                type="text"
                class="form-control"
                placeholder="Critério"
                v-model="row.criterion"
                disabled
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="3">
              <label>Resultado</label>
              <input
                type="text"
                class="form-control"
                placeholder="Resultado"
                v-model="row.result"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Limite de tolerância</label>
              <input
                type="text"
                class="form-control"
                placeholder="Limite de tolêrancia"
                v-model="row.limit"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Conclusão</label>
              <input
                type="text"
                class="form-control"
                placeholder="Conclusão"
                v-model="row.conclusion"
                required
              />
            </d-col>
          </d-form-row>
        </d-col>
      </d-list-group-item>
    </d-list-group>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { VIBRATION_RESULT, _LOAD_MODEL_, _UPDATE_SAMPLE_CRITERION_VIBRATION_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Vibration',
  props: {
    result: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: cloneDeep(VIBRATION_RESULT),
      currentCriterion: null,
      baseResult: [],
    };
  },
  computed: {
    rowsCount() {
      return this.currentCriterion === 'AREN/VDVR' ? 2 : 1;
    },
  },
  methods: {
    setModel() {
      const rows = this.rowsCount;
      const newModel = [];
      const criterion = ['AREN', 'VDVR'];

      for (let i = 0; i < rows; i += 1) {
        const base = (this.baseResult && this.baseResult[i]) || VIBRATION_RESULT[0];
        newModel.push(cloneDeep({ ...base, criterion: criterion[i] }));
      }

      this.model = newModel;
    },
    handleLoadModel() {
      this.setModel();
    },
    handleRowsResult(agent) {
      this.currentCriterion = agent?.criterion || null;
      this.handleLoadModel();
    },
  },
  mounted() {
    this.baseResult = cloneDeep(this.result);
    const { sample } = this.$store.state.sample;
    this.currentCriterion = sample?.memory_field?.criterion || null;
    this.handleLoadModel();
    Events.$on(_LOAD_MODEL_, this.setModel);
    Events.$on(_UPDATE_SAMPLE_CRITERION_VIBRATION_, this.handleRowsResult);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this.setModel);
    Events.$off(_UPDATE_SAMPLE_CRITERION_VIBRATION_, this.handleRowsResult);
  },
  watch: {
    model: {
      handler(value) {
        if (!this.baseResult) {
          this.baseResult = [];
        }
        value.forEach((row, index) => {
          this.baseResult[index] = cloneDeep(row);
        });
        this.$emit('update:result', value);
      },
      deep: true,
    },
  },
};
</script>
